import { createSWRegistration } from "kz-ui-sdk";
import { deployEnvConfig } from "@configs/deploy-env";
import { getSWCacheVersion } from "@utils/sw";


export const swRegistration = createSWRegistration(window, {
  accountId: deployEnvConfig.country.accountId,
  publicUrl: import.meta.env.VITE_PUBLIC_URL ?? "",
  fileName: "service-worker.js",
  notificationURI: import.meta.env.VITE_PUSH_NOTIFICATION_URI,
  notificationInfoEndpoint: "/notification/info",
  env: import.meta.env.VITE_DEBUG_NOTIFICATION ? 'production' : import.meta.env.MODE,
  getVersion: getSWCacheVersion,
})
